// src/components/MenuItem.js
import React from 'react';
import './MenuItem.css';

const MenuItem = ({ name, description, price, image }) => {
  return (
    <div className="menu-item">
      <img src={image} alt={name} className="menu-item-image" />
      <div className="menu-item-details">
        <h3>{name}</h3>
        <p>{description}</p>
        <span className="price">{price}</span>
      </div>
    </div>
  );
};

export default MenuItem;